import React from 'react';
import PropTypes from 'prop-types';

const PriceField = ({ source, record = {} }) => {
  const dollars = record[source];
  if (dollars === null || dollars === undefined) {
    return <span />;
  }

  return <span>${dollars.toFixed(2)}</span>;
};

PriceField.defaultProps = {
  record: {},
};

PriceField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default PriceField;
